import { EducationDocument } from "services/educationDocuments/response";

type EducationDocumentProperty = keyof EducationDocument;

export  const catName: EducationDocumentProperty = "categoryName";